// src/services/ragService.ts
// Retrieval-Augmented Generation service
// Mengambil konteks relevan dari knowledge base sebelum mengirim ke Gemini

import { searchKnowledgeBase } from "../data/noiseKnowledgeBase";
import { NoiseSummary } from "../types/chatTypes";
import {
  formatNoiseSummaryForContext,
  isStatisticsQuery,
} from "./noiseDataService";

/**
 * Membangun konteks RAG dari query user.
 * 1. Cari knowledge base lokal yang relevan
 * 2. Jika user bertanya statistik, sertakan data noise summary
 * 3. Gabungkan semua konteks menjadi satu string
 */
export function buildRAGContext(
  query: string,
  noiseSummary: NoiseSummary | null
): string {
  const parts: string[] = [];

  // 1. Ambil dokumen relevan — hanya 2 teratas untuk hemat token
  const relevantDocs = searchKnowledgeBase(query, 2);
  if (relevantDocs.length > 0) {
    parts.push("=== INFO ===");
    relevantDocs.forEach((doc, i) => {
      // Trim content panjang
      const content = doc.content.length > 300 ? doc.content.slice(0, 300) + "..." : doc.content;
      parts.push(`[${i + 1}] ${content}`);
    });
  }

  // 2. Sertakan data real-time hanya jika query berkaitan statistik/wilayah
  if (noiseSummary && (isStatisticsQuery(query) || noiseSummary.total > 0)) {
    parts.push("\n=== DATA PETA ===");
    parts.push(formatNoiseSummaryForContext(noiseSummary));
  }

  return parts.length > 0 ? parts.join("\n") : "";
}
